import lodash from 'lodash';
export const numFormat = (value) => {
    const param = { value: 0, unit: '' };
    let limit = 10000, i;
    if (value < limit) {
        param.value = value;
        param.unit = '';
    }
    else {
        param.value = lodash.ceil(lodash.divide(value, limit), 1);
        param.unit = 'w+';
    }
    return param.value + param.unit;
};
